import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const Storage = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.storage.title",
            defaultMessage: "Storage"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.storage.body",
            defaultMessage:
                "Products in the Jira suite and Confluence all come with their own file storage space."
        }),
        link: intl.formatMessage(
            {
                id: "ConfluencePricingPage.modal-content.storage.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about storage."
            },
            {
                learnMore: (chunks: React.ReactNode) => (
                    <a
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        href={`https://support.atlassian.com${useLocalizedHref(
                            "/security-and-access-policies/docs/track-storage-and-move-data-across-products/"
                        )}`}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="confluence"
                        data-track-event="ConfluencePricingPage.storage"
                        data-event-container="ConfluencePricingPage"
                    >
                        {chunks}
                    </a>
                )
            }
        )
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </div>
    );
};

export default Storage;
